import { actions } from './actions'

const initialState = {
  descuentos: {
    data: [],
    loading: false,
    error: '',
  },
  descuento: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function descuentosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DESCUENTOS_LOAD_REQUESTED:
      return { ...state, descuentos: { ...state.descuentos, data: null, loading: true } }
    case actions.DESCUENTOS_LOAD_SUCCEEDED:
      return {
        ...state,
        descuentos: { ...state.descuentos, data: action.payload, loading: false, reload: false },
      }
    case actions.DESCUENTOS_LOAD_FAILED:
      return {
        ...state,
        descuentos: { ...state.descuentos, loading: false, error: action.error },
      }
    case actions.SET_DESCUENTO_USADO_REQUESTED:
      return { ...state, descuento: { ...state.descuentos, data: null, loading: true } }
    case actions.SET_DESCUENTO_USADO_SUCCEEDED: {
      const updatedArray = state.descuentos.data.map(element =>
        element.id === action.payload.id ? action.payload : element,
      )
      return {
        ...state,
        descuentos: { ...state.descuentos, data: updatedArray, loading: false, reload: false },
      }
    }
    case actions.SET_DESCUENTO_USADO_FAILED:
      return {
        ...state,
        descuentos: { ...state.descuentos, loading: false, error: action.error },
      }
    case actions.DELETE_DESCUENTO_REQUESTED:
      return { ...state, descuento: { ...state.descuentos, data: null, loading: true } }
    case actions.DELETE_DESCUENTO_SUCCEEDED: {
      return {
        ...state,
        descuentos: {
          ...state.descuentos,
          data: state.descuentos.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_DESCUENTO_FAILED:
      return {
        ...state,
        descuentos: { ...state.descuentos, loading: false, error: action.error },
      }
    case actions.DESCUENTO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        descuento: { ...state.descuento, loading: true, error: '' },
      }
    case actions.DESCUENTO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        descuento: { ...state.descuento, data: action.payload, loading: false, error: '' },
      }
    case actions.DESCUENTO_BYID_LOAD_FAILED:
      return {
        ...state,
        descuento: { ...state.descuento, data: null, loading: false, error: action.error },
      }
    case actions.DESCUENTO_UPDATE_REQUESTED:
      return {
        ...state,
        descuento: { ...state.descuento, loading: true, error: '' },
      }
    case actions.DESCUENTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        descuento: { ...state.descuento, data: action.payload, loading: false, error: '' },
      }
    case actions.DESCUENTO_UPDATE_FAILED:
      return {
        ...state,
        descuento: { ...state.descuento, loading: false, error: action.error },
      }
    case actions.DESCUENTO_INSERT_REQUESTED:
      return {
        ...state,
        descuento: { ...state.descuento, loading: true, error: '' },
      }
    case actions.DESCUENTO_INSERT_SUCCEEDED:
      return {
        ...state,
        descuento: { ...state.descuento, data: action.payload, loading: false, error: '' },
      }
    case actions.DESCUENTO_INSERT_FILED:
      return {
        ...state,
        descuento: { ...state.descuento, loading: false, error: action.error },
      }
    case actions.DESCUENTOS_FILTERED_LOAD_REQUESTED:
      return { ...state, descuentos: { ...state.descuentos, data: null, loading: true } }
    case actions.DESCUENTOS_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        descuentos: { ...state.descuentos, data: action.payload, loading: false },
      }
    case actions.DESCUENTOS_FILTERED_LOAD_FILED:
      return {
        ...state,
        descuentos: { ...state.descuentos, loading: false, error: action.error },
      }
    default:
      return state
  }
}
